import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import MessagesList from './components/MessagesList/MessagesList';

import logo from './assets/images/logo.png';
import present from './assets/images/present.png';

import posterDefault from './assets/images/poster.png';
import bgDefaultVideo from './assets/video/bgVideo.mp4';
import { useEffect } from 'react';
import { useVote } from './hooks/useVote';
import { useMemo } from 'react';

function App() {
  const { voteState, voteActivity: isVisible } = useVote();
  const {
    currentState,
    // isVisible,
    showedMessages,
    messagesRef,
    winnerMessage,
    speed,
    setSpeed,
  } = useCarousel();

  const {
    authorFontSize,
    msgFontSize,
    phoneNumberFontSize,
    bgVideo,
    bgPoster,
    speedSlow,
    speedFast,
  } = useGetParams();

  useEffect(() => {
    setTimeout(() => {
      if (currentState === 'S2' && speed !== speedSlow) {
        setSpeed(speedSlow);
      } else if (currentState === 'S3' && speed !== speedFast) {
        setSpeed(speedFast);
      }
    }, [500]);
  }, [currentState]);

  const prize = useMemo(() => {
    const isCorrect = voteState?.vars.find((v) => v.correct)?.varImgUrl;

    return isCorrect ? isCorrect : present;
  }, [voteState]);

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      {/* <div className="title">РОЗЫГРЫШ ПРИЗОВ ОТ</div> */}
      {/* <img src={logo} alt="logo" className="logo" /> */}

      <CSSTransition
        in={true}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <CSSTransition
          in={showedMessages && Boolean(currentState)}
          timeout={500}
          // classNames="fade-scale"
          unmountOnExit>
          <MessagesList
            winId={winnerMessage?.message.id}
            messages={showedMessages}
            authorFontSize={authorFontSize}
            msgFontSize={msgFontSize}
            phoneNumberFontSize={phoneNumberFontSize}
            currentState={currentState}
            speed={speed || 0}
          />
        </CSSTransition>
      </CSSTransition>

      {voteState && (
        <SwitchTransition>
          <CSSTransition
            appear={true}
            key={prize}
            addEndListener={(node, done) =>
              node.addEventListener('transitionend', done, false)
            }
            classNames="fade">
            <div className="logo">
              <div className="holoContainer">
                <div className="holo" />
              </div>
              <img src={logo} alt="logo" className="logoImg" />
            </div>
          </CSSTransition>
        </SwitchTransition>
      )}

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo">
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/mp4"></source>
        </video>
      )}
      <div id="img-loader" />
    </div>
  );
}

export default App;
